var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComoros(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_7128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 512C397.385 512 512 397.385 512 256C512 114.615 397.385 0 256 0C114.615 0 0 114.615 0 256C0 397.385 114.615 512 256 512Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.991 255.259H234.481C179.384 310.357 146.066 352.894 112.046 386.914L256.742 399.954L481.276 377.693C500.871 341.498 512 300.049 512 256C512 255.752 511.991 255.507 511.991 255.259V255.259Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.047 132.824H480.459C436.921 53.656 352.731 0 256 0C185.495 0 121.659 28.511 75.3643 74.624L112.047 132.824Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.177 377.693C100.163 400.707 91.2692 419.989 74.6182 436.639C120.973 483.186 185.118 512 256 512C353.336 512 437.98 457.675 481.277 377.693H123.177Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9795 74.239C-24.9945 174.213 -24.9945 336.304 74.9795 436.279C116.293 394.966 156.026 355.233 256 255.259L74.9795 74.239Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5248 255.259C67.5248 217.961 93.7378 186.802 128.742 179.158C123.362 177.983 117.78 177.346 112.046 177.346C69.0148 177.346 34.1328 212.228 34.1328 255.259C34.1328 298.29 69.0148 333.172 112.046 333.172C117.779 333.172 123.361 332.535 128.742 331.36C93.7378 323.715 67.5248 292.557 67.5248 255.259V255.259Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.883 188.476L132.028 201.23H145.438L134.588 209.113L138.733 221.867L127.883 213.985L117.033 221.867L121.178 209.113L110.328 201.23H123.738L127.883 188.476Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.883 221.867L132.028 234.622H145.438L134.588 242.504L138.733 255.259L127.883 247.376L117.033 255.259L121.178 242.504L110.328 234.622H123.738L127.883 221.867Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.883 255.259L132.028 268.013H145.438L134.588 275.896L138.733 288.65L127.883 280.767L117.033 288.65L121.178 275.896L110.328 268.013H123.738L127.883 255.259Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.883 288.65L132.028 301.404H145.438L134.588 309.287L138.733 322.041L127.883 314.159L117.033 322.041L121.178 309.287L110.328 301.404H123.738L127.883 288.65Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_7128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComoros);
export default __webpack_public_path__ + "static/media/comoros.ac4e7a4f0d1f2c7c3c53136d33925d24.svg";
export { ForwardRef as ReactComponent };